// src/store/store.js
import { createStore, combineReducers, applyMiddleware, compose  } from 'redux';
import notificationReducer from 'Store/reducers/notificationReducer';
import profileListReducer from './reducers/profileListReducer';
import { thunk } from 'redux-thunk';
import employeeListReducer from './reducers/employeeListReducer';

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    notification: notificationReducer,
    profileList: profileListReducer,
    employeeList: employeeListReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
